import React from 'react';

import AlertIcon from './mdi_comment-alert.svg';
import ArrowRight from './mdi_chevron-right-circle-outline.svg';

import '../landing-components-base/claims-button.scss';
import { Col, Grid, Row } from 'rsuite';

export const ClaimButton = ({ title, msg }) => {

    const handleClick = () => {
        window.open('https://requerimientos.achs.cl', '_blank');
    };

    return (
        <div className={'claim-button-base'} onClick={() => handleClick()}>
            <Grid fluid>
                <Row className='show-grid'>
                    <Col xs={2}><img src={AlertIcon} alt={''} /></Col>
                    <Col xs={21}>
                        <div className={'claim-button-content'}>
                            <div className={'claim-button-content-title'}>{title}</div>
                            {msg}
                        </div>
                    </Col>
                    <Col xs={1}><img className={'arrow-icon'} src={ArrowRight} alt={''} /></Col>
                </Row>
            </Grid>
        </div>
    );
};
